import title_txt_lobby from "../images/common/banner/img_lobby_title.png";
import title_union_lobby from "../images/common/banner/img_lobby_union.png";

import title_txt_lounge from "../images/common/banner/img_lounge_title.png";
import title_union_lounge from "../images/common/banner/img_lounge_union.png";

import title_txt_privateroom_pc from "../images/common/banner/img_privateroom_title-pc.png";
import title_txt_privateroom_tab from "../images/common/banner/img_privateroom_title-tab.png";
import title_txt_privateroom_mo from "../images/common/banner/img_privateroom_title-mo.png";
import title_union_privateroom from "../images/common/banner/img_privateroom_union.png";

export const bannerLobby = {
  classType: "banner type-lobby",
  title: 'lobby',
  titleSrcPc: title_txt_lobby,
  titleSrcTab: title_txt_lobby,
  titleSrcMo: title_txt_lobby,
  unionSrc: title_union_lobby,
  description1: '끌레를 찾기 위한 여정의 시작',
  description2: '웅장하고 광활한 공간으로 초대해요.',
  linkDesc: '로비 둘러보기',
  link: '/daejeon/lobby',
};
export const bannerLounge = {
    classType: "banner type-lounge",
    title: 'lounge',
    titleSrcPc: title_txt_lounge,
    titleSrcTab: title_txt_lounge,
    titleSrcMo: title_txt_lounge,
    unionSrc: title_union_lounge,
    description1: '더 안전하고 편안한 여정을 함께할',
    description2: '맞춤형 공간을 소개해요.',
    linkDesc: '라운지 둘러보기',
    link: '/daejeon/lounge',
};
export const bannerPrivateroom = {
    classType: "banner type-privateroom",
    title: 'private room',
    titleSrcPc: title_txt_privateroom_pc,
    titleSrcTab: title_txt_privateroom_tab,
    titleSrcMo: title_txt_privateroom_mo,
    unionSrc: title_union_privateroom,
    description1: '프라이빗하지만 넓고 안락함',
    description2: '모두 갖춘 공간을 준비했어요.',
    linkDesc: '프라이빗룸 둘러보기',
    link: '/daejeon/privateroom',
}